import config from "./config";

export default ({ url, fileName }) => {
  if (!fileName) {
    return "Kindly provide a filename to download";
  }

  const linkUrl = url
    ? url
    : `${config.get("VUE_APP_DOWNLOAD_URL")}${fileName}`;
  const link = document.createElement("a");
  link.href = linkUrl;
  link.download = fileName;
  link.click();
};
